import { TFunction } from 'react-i18next';

import { useMappedTranslation } from 'hooks/useMappedTranslation';

import { getMappedTranslation } from 'utility/Translate/mappedTranslation';

import { MealType } from 'proto/Offer/MealType';

const mealTypeTranslationKeyMap: Partial<Record<MealType, string>> = {
    [MealType.Breakfast]: 'TRANS-mealtype-breakfast',
    [MealType.AllInclusive]: 'TRANS-mealtype-allinclusive',
    [MealType.AllInclusivePlus]: 'TRANS-mealtype-allinclusiveplus',
    [MealType.AllInclusivePremium]: 'TRANS-mealtype-allinclusivepremium',
    [MealType.AllInclusiveUltra]: 'TRANS-mealtype-allinclusiveultra',
    [MealType.AllInclusiveLight]: 'TRANS-mealtype-allinclusivelight',
    [MealType.FullBoard]: 'TRANS-mealtype-fullboard',
    [MealType.FullBoardPlus]: 'TRANS-mealtype-fullboardplus',
    [MealType.HalfBoard]: 'TRANS-mealtype-halfboard',
    [MealType.HalfBoardPlus]: 'TRANS-mealtype-halfboardplus',
    [MealType.HalfBoardUltra]: 'TRANS-mealtype-halfboardultra',
    [MealType.Special]: 'TRANS-mealtype-special',
    [MealType.None]: 'TRANS-mealtype-none',
    [MealType.Program]: 'TRANS-mealtype-program',
};

const mealTypeTooltipTranslationKeyMap: Partial<Record<MealType, string>> = {
    [MealType.Breakfast]: 'TRANS-mealtype-tooltip-breakfast',
    [MealType.AllInclusive]: 'TRANS-mealtype-tooltip-allinclusive',
    [MealType.AllInclusivePlus]: 'TRANS-mealtype-tooltip-allinclusiveplus',
    [MealType.AllInclusivePremium]:
        'TRANS-mealtype-tooltip-allinclusivepremium',
    [MealType.AllInclusiveUltra]: 'TRANS-mealtype-tooltip-allinclusiveultra',
    [MealType.AllInclusiveLight]: 'TRANS-mealtype-tooltip-allinclusivelight',
    [MealType.FullBoard]: 'TRANS-mealtype-tooltip-fullboard',
    [MealType.FullBoardPlus]: 'TRANS-mealtype-tooltip-fullboardplus',
    [MealType.HalfBoard]: 'TRANS-mealtype-tooltip-halfboard',
    [MealType.HalfBoardPlus]: 'TRANS-mealtype-tooltip-halfboardplus',
    [MealType.HalfBoardUltra]: 'TRANS-mealtype-tooltip-halfboardultra',
    [MealType.Special]: 'TRANS-mealtype-tooltip-special',
    [MealType.None]: 'TRANS-mealtype-tooltip-none',
    [MealType.Program]: 'TRANS-mealtype-tooltip-program',
};

export const useMealTypeLabel = (mealType: MealType | undefined) =>
    useMappedTranslation(
        mealTypeTranslationKeyMap,
        mealType,
        'TRANS-mealtype-program'
    );

export const buildMealTypeLabel = (
    mealType: MealType | undefined,
    t: TFunction
) =>
    getMappedTranslation(
        mealTypeTranslationKeyMap,
        mealType,
        t,
        'TRANS-mealtype-program'
    );

export const useMealTypeTooltip = (mealType: MealType | undefined) =>
    useMappedTranslation(
        mealTypeTooltipTranslationKeyMap,
        mealType,
        'TRANS-mealtype-tooltip-program'
    );

export const buildMealTypeTooltip = (
    mealType: MealType | undefined,
    t: TFunction
) =>
    getMappedTranslation(
        mealTypeTooltipTranslationKeyMap,
        mealType,
        t,
        'TRANS-mealtype-tooltip-program'
    );
